import getExtension from './extension';
import getExtensionConfiguration from './extension-configuration';

const getExtensionSettings = (rootState, slug) => {
  const targetExtension = getExtension(rootState, slug) || {};
  const extensionMeta = getExtensionConfiguration(rootState, slug) || {};

  return {
    ...targetExtension.defaults,
    ...extensionMeta.settings,
  };
};

export default getExtensionSettings;
